import { IconAngleRight } from '@iwoca/icons';
import { Link, useLocation } from 'react-router';

import shopIconSVG from './shopIcon.svg';

export const SellerDirectoryBanner = () => {
  const { search } = useLocation();

  return (
    <div className="my-xs box-border flex w-full items-start justify-start gap-l rounded-s border border-solid border-secondary-90 px-l py-m">
      <img
        src={shopIconSVG}
        alt="Shop icon"
        className="h-auto w-[50px] flex-shrink-0"
      />
      <div className="flex flex-col">
        <Link
          to={{ pathname: 'directory', search }}
          className="inline-flex items-center gap-xs text-left text-m font-bold !text-primary-40 no-underline hover:underline"
        >
          Find an iwocaPay supplier{' '}
          <IconAngleRight className="fill-primary-40" />
        </Link>
        <span className="text-s font-reg">
          You can use your spending limit at any supplier that offers iwocaPay
          Pay Later. Just choose iwocaPay at the checkout.
        </span>
      </div>
    </div>
  );
};
